import { gql } from "@apollo/client";

export const CELLCARD_VERIFY_DOCUMENT = gql`
  mutation CellcardVerifyDocument($document: String!) {
    CellcardVerifyDocument(document: $document) {
      no_return
      name
      trading_name
      many_users_found
    }
  }
`;

export const SIGN_IN_OAUTH2 = gql`
  mutation SignInOAuth2(
    $document: String
    $store: String
    $login: String!
    $password: String!
  ) {
    SignInOAuth2(
      document: $document
      store: $store
      login: $login
      password: $password
    ) {
      no_return
    }
  }
`;

export const REQUEST_EVENTS = gql`
  mutation RequestEvents(
    $kind: String!
    $store: String
    $login: String!
    $document: String
  ) {
    RequestEvents(
      kind: $kind
      store: $store
      login: $login
      document: $document
    ) {
      status
      id
      status_reason
    }
  }
`;

export const VERIFY_EVENTS = gql`
  mutation VerifyEvents($token: String!, $id: String!) {
    VerifyEvents(token: $token, id: $id) {
      status
      id
    }
  }
`;
